import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'antd';
import Beyond from '@/assets/images/beyond-2g.png';
import AudioFormat from '@/assets/images/audio-format.png';
import ThousandSite from '@/assets/images/thousand-site.png';
import VCImg from '@/assets/images/vc-ok.png';
import Process from '@/components/common/process/Process';
import { ReactComponent as WindowsLogo } from '@/assets/icons/win.svg';
import { ReactComponent as MacLogo } from '@/assets/icons/mac-icon.svg';
import FaiFailedOrSuccess from './HeaderComponent/FailedOrSuccess/FailedOrSuccess';
import { useTranslation } from 'react-i18next';
import Progress from './progress/index';
import './index.less';
import { useDispatch, useSelector } from 'react-redux';
import actions from '@/redux/action';
import Cookies from 'js-cookie';
import Utils from '../../../utils';
import sendGaEvent from '@/ga';

var TableView = undefined;
export default function ModalAdvertise(props) {
  const { t } = useTranslation('advertise');
  const { t: t2 } = useTranslation();
  const isDesk = Utils.getSystemType();
  const reducerData = useSelector((state) => state.common);
  const workReducer = useSelector((state) => state.work);
  const dispatch = useDispatch();
  // const [sureVisible, setSureVisible] = useState(false);
  const { percent } = reducerData;

  const {
    isShowBtn, //是否显示not Now 的按钮
    isShowHeader,
    headerObj, //是否显示对话框头部,以及展示类型
    titleIndex, //标题
    imgIndex, //图片展示
    source, //对话框开启的原因来源
  } = reducerData.advertiseConfig;

  const imgGroup = [
    { img: Beyond },
    { img: AudioFormat },
    { img: ThousandSite },
    { img: VCImg },
  ];
  const title = [
    { title: t('DownloadDesktopNoLimit') },
    { title: t('Convert300FormatsByDesktop') },
    { title: t('ExtractingAudioInThousandsSites') },
    { title: t('120XFasterToConvert') },
    { title: '' },
    { title: t('120XDownloadVideoFromWebsites') },
  ];

  const content = [
    { content: t('BachThousandOfFormats') },
    { content: t('DownloadVIdeoByThousandsOfSites') },
    { content: t('RichEditingFeatures') },
    { content: t('ConvertMusicWithDrm') },
  ];

  const getCloseAction = (source) => {
    switch (source) {
      case 'fontUrl':
        return 'AudioExtractor_UnderChooseFileClose';
      // case 'exceed20M':
      //     return 'AudioExtractor_SizeExceed20MDownload';
      case 'exceed2G':
        return 'AudioExtractor_SizeExceed2GClose';
      case 'format':
        return 'AudioExtractor_FormatChoose300+Close';
      case 'extract':
        return 'AudioExtractor_ExtractingClose';
      case 'failed':
        return 'AudioExtractor_ExtractFailedClose';
      case 'extractSuccess':
        return 'AudioExtractor_UnderExtractedSuccessfullyClose';
      case 'download':
        return 'AudioExtractor_DownloadingClose';
      case 'success':
        return 'AudioExtractor_DownloadSuccessfullyClose';
      default:
        return 'default';
    }
  };

  const getDownloadAction = (source) => {
    switch (source) {
      case 'fontUrl':
        return 'AudioExtractor_UnderChooseFileDownload';
      case 'exceed20M':
        return 'AudioExtractor_SizeExceed20MDownload';
      case 'exceed2G':
        return 'AudioExtractor_SizeExceed2GDownload';
      case 'format':
        return 'AudioExtractor_FormatChoose300+Download';
      case 'extract':
        return 'AudioExtractor_ExtractingDownload';
      case 'failed':
        return 'AudioExtractor_ExtractFailedDownload';
      case 'extractSuccess':
        return 'AudioExtractor_UnderExtractedSuccessfullyDownload';
      case 'download':
        return 'AudioExtractor_DownloadingDownload';
      case 'success':
        return 'AudioExtractor_DownloadSuccessfullyDownload';
      default:
        return 'default';
    }
  };

  const closeDialog = () => {
    if (getCloseAction(source) != 'default') {
      sendGaEvent({
        category: 'vc_referral',
        action: getCloseAction(source),
      });
    }
    stopSure();
    // if (headerObj == "extract" || headerObj == "download") {
    //     setSureVisible(true);
    // } else {
    //     dispatch(actions.openAdvertiseDialog(false));
    // }

    //dispatch(actions.openAdvertiseDialog(false));
  };

  // const cancelSure = () => {
  //     setSureVisible(false);
  // }
  //终端提取或者下载流程
  const stopSure = () => {
    console.log(headerObj, TableView);
    if (headerObj == 'extract' && TableView != undefined) {
      if (props.cancelProcessCallBack) {
        props?.cancelProcessCallBack();
      }
      TableView.cancelProcess();
    }
    if (headerObj == 'download') {
      if (workReducer.uploadXHR) workReducer.uploadXHR.abort();
    }
    //setSureVisible(false)
    dispatch(actions.openAdvertiseDialog(false));
  };
  ///////////not Now 按钮点击事件
  const notNow = () => {
    //点击notNow 30天不弹出该类型广告
    Cookies.set('ignoreAdvertise', 'ignoreAdvertise', { expires: 30 });
    sendGaEvent({
      category: 'vc_referral',
      action: 'AudioExtractor_SizeExceed20MNotNow',
    });
    closeDialog();
  };
  ///////下载桌面端
  const downloadDesktop = () => {
    console.log(source, getDownloadAction(source));
    Cookies.set('ignoreAdvertise', 'ignoreAdvertise', { expires: 30 });
    if (getDownloadAction(source) != 'default') {
      sendGaEvent({
        category: 'vc_referral',
        action: getDownloadAction(source),
      });
    }
    window.location.href = Utils.getHitPawConvertLink();
    // closeDialog();
  };
  /////////下载进度到100后，进入下载成功页面
  useEffect(() => {
    if (percent == 100) {
      dispatch(
        actions.advertiseConfig({
          isShowBtn: false,
          isShowHeader: true,
          headerObj: 'success',
          titleIndex: 5,
          imgIndex: 2,
          source: 'success',
        })
      );
      sendGaEvent({
        category: 'vc_referral',
        action: 'AudioExtractor_DownloadSuccessfullyShow',
      });
    }
  }, [percent]);

  return (
    <div>
      <Modal
        className='advertiseModal'
        maskClosable={false}
        onCancel={() => closeDialog()}
        bodyStyle={{
          backgroundColor: '#F8F8FA',
          borderRadius: 24,
        }}
        title={
          isShowHeader ? (
            headerObj == 'extract' ? (
              <div className='process'>
                <Process
                  onRef={(ref) => {
                    TableView = ref;
                  }}
                  visible
                  theme='light'
                  showProcessText
                  processText={t2('audioExtractor:Extracting Audio')}
                  hideCancelText
                  //cancelProcessCallBack={props.cancelProcessCallBack}
                />
              </div>
            ) : headerObj == 'download' ? (
              <Progress t={t} percent={percent} />
            ) : (
              <FaiFailedOrSuccess t={t} status={headerObj} />
            )
          ) : null
        }
        centered
        width={800}
        footer={null}
        //visible={true}
        visible={reducerData.advertiseDialog}
      >
        <div className='modalBody'>
          <div className='contentTitle'>{title[titleIndex].title}</div>
          <div className='contentBody'>
            <div className='bodyContent'>
              <ul>
                {content.map((item, value) => {
                  return (
                    <li key={'bodyContentList' + value} className='li'>
                      {item.content}
                    </li>
                  );
                })}
              </ul>
              <div className='buttonGroup'>
                <Button
                  //href={Utils.getHitPawConvertLink()}
                  onClick={() => downloadDesktop()}
                  type='primary'
                  className='freeDownload'
                >
                  <div>
                    {isDesk == 'Windows' ? (
                      <WindowsLogo
                        style={{
                          width: 18,
                        }}
                      />
                    ) : (
                      <MacLogo
                        style={{
                          width: 18,
                        }}
                      />
                    )}{' '}
                    {t('Try It Free')}
                  </div>
                </Button>
                {isShowBtn ? (
                  <Button
                    onClick={() => notNow()}
                    type='default'
                    className='notNow'
                  >
                    {} {t('NotNow')}
                  </Button>
                ) : null}
              </div>
            </div>
            <div className='bodyImage'>
              <img className='advertiseImage' src={imgGroup[imgIndex].img} />
            </div>
          </div>
        </div>
      </Modal>
      {/* <Modal
                className='sureModal'
                centered
                width={500}
                bodyStyle={{
                    marginLeft: 16
                }}
                onCancel={() => cancelSure()}
                title={null}
                footer={null}
                visible={sureVisible}
                maskClosable={false}>
                <div className='sureModalBody'>
                    <div>
                        {headerObj == "extract" ? t("SureToStopExtract") : t('Are you sure to stop downloading audio?')
                        }

                    </div>
                    <div className='buttonGroup'>
                        <div>
                            <Button onClick={() => cancelSure()} className='cancelBtn' type="default">{t("Cancel")}</Button>
                            <Button onClick={() => stopSure()} className='stopBtn' type="primary">{t("Stop")}</Button>
                        </div>

                    </div>
                </div>

            </Modal> */}
    </div>
  );
}
